/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import axios from '@nextcloud/axios';
import { subscribe } from '@nextcloud/event-bus';
import { loadState } from '@nextcloud/initial-state';
import { generateOcsUrl } from '@nextcloud/router';
import Vue, { defineAsyncComponent } from 'vue';
const navigationEntries = loadState('core', 'apps', []);
const DialogVue = defineAsyncComponent(() => import('./components/AppChangelogDialog.vue'));
/**
 * Show the app changelog dialog
 *
 * @param appId The app to show the changelog for
 * @param version Optional version to show
 */
function showDialog(appId, version) {
    const element = document.createElement('div');
    document.body.appendChild(element);
    return new Promise((resolve) => {
        let dismissed = false;
        const dialog = new Vue({
            el: element,
            render: (h) => h(DialogVue, {
                props: {
                    appId,
                    version,
                },
                on: {
                    dismiss: () => { dismissed = true; },
                    'update:open': (open) => {
                        if (!open) {
                            dialog.$destroy?.();
                            resolve(dismissed);
                            const app = navigationEntries.find(({ app }) => app === appId);
                            if (dismissed && app !== undefined) {
                                window.location.href = app.href;
                            }
                        }
                    },
                },
            }),
        });
    });
}
subscribe('notifications:action:execute', (event) => {
    if (event.notification.objectType === 'app_updated') {
        event.cancelAction = true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [_, app, version, __] = event.action.url.match(/(?<=\/)([^?]+)?version=((\d+.?)+)/) ?? [];
        showDialog(app || event.notification.objectId, version)
            .then((dismissed) => {
            if (dismissed) {
                axios.delete(generateOcsUrl('apps/notifications/api/v2/notifications/{id}', { id: event.notification.notificationId }));
            }
        });
    }
});
